import { createAsyncThunk } from "@reduxjs/toolkit";
import apiService from "../../../../services/apiService";

const DASHBOARD_FLOW_SLICE_NAME = "dashboardFlow";
const dashboardThunkActions = {
  dashboardGroupList: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/dashboardGroupList`,
    async (businessId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.dashboardGroupList(businessId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  dashboardList: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/dashboardList`,
    async (dashboardGroupId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.dashboardList(dashboardGroupId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  homeDashboardListing: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/homeDashboardListing`,
    async (dashboardGroupId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.homeDashboardListing();
        const response = JSON.parse(apiResponse?.data)?.data || {};
        const apiResponse2 = await apiService.homeDashboardListingById(response?.id);
        const apiResponse2Json=JSON.parse(apiResponse2?.data)?.data || {};
        return {...response,...apiResponse2Json} || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  reportListingDashboard: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/reportListingDashboard`,
    async (dashboardId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.reportListingDashboard(
          dashboardId
        );
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  reportListing: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/reportListing`,
    async (dashboardId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.reportListing(dashboardId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  dashboardChartList: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/dashboardChartList`,
    async (reportId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.dashboardChartList(reportId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  chartListing: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/chartListing`,
    async (dashboardId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.chartListing();
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  mapReportToDashboard: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/mapReportToDashboard`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.mapReportToDashboard(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  reportById: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/reportById`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.reportById(payload);
        let response = JSON.parse(apiResponse?.data)?.data || {};
        response = [{ id: payload.dashboardId, reports: [response] }];
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  businessList: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/businessList`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.businessList();
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  reportList: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/reportList`,
    async (dashboardId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.reportList(dashboardId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  chartList: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/chartList`,
    async (dashboardId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.chartList(dashboardId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),

  dashboardGroupCreate: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/dashboardGroupCreate`,
    async (groupaName, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.createDashboardGroup(groupaName);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  dashboardCreate: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/dashboardCreate`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.createDashboard(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  reportCreate: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/reportCreate`,
    async (reportName, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.createReport(reportName);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  chartCreate: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/chartCreate`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.chartCreate(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  chartUpdate: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/chartUpdate`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.chartUpdate(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  chartDelete: createAsyncThunk(
    `${DASHBOARD_FLOW_SLICE_NAME}/chartDelete`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.chartDelete(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
};

export default dashboardThunkActions;
